import request from '@/plugins/axios'

//删除用户
export function deleteUser(params) {
    return request({
        url: '/user/deleteUser/' + params,
        method: 'get'
    })
}

//添加用户
export function addUser(data) {
    return request({
        url: '/user/addUser',
        method: 'post',
        data
    })
}

//查询单个用户
export function getUser(params) {
    return request({
        url: '/user/getUser/' + params,
        method: 'get'
    })
}

//获取用户列表
export function listUser(params) {
    return request({
        url: '/user/listUser',
        method: 'get',
        params
    })
}

//修改个人信息
export function updateMy(data) {
    return request({
        url: '/user/updateMy',
        method: 'post',
        data
    })
}

//修改用户信息
export function updateUser(data) {
    return request({
        url: '/user/updateUser',
        method: 'post',
        data
    })
}



//获取用户token
export function getUserToken(params) {
    return request({
        url: '/open/getUserToken',
        method: 'post',
        params
    })
}


//获取用户认证信息列表
export function listUserAuthInfo(params) {
    return request({
        url: '/user/listUserAuthInfo',
        method: 'get',
        params
    })
}

//添加用户认证信息
export function addUserAuthInfo(data) {
    return request({
        url: '/user/addUserAuthInfo',
        method: 'post',
        data
    })
}

//查询单个用户认证信息
export function getUserAuthInfo(params) {
    return request({
        url: '/user/getUserAuthInfo/' + params,
        method: 'get'
    })
}

//修改用户认证信息
export function updateUserAuthInfo(data) {
    return request({
        url: '/user/updateUserAuthInfo',
        method: 'post',
        data
    })
}


//修改状态
export function checkUserAuthInfo(params) {
    return request({
        url: '/user/checkUserAuthInfo',
        method: 'post',
        params
    })
}

//强制下线
export function setOffline(params) {
    return request({
        url: '/user/setOffline/' + params,
        method: 'get'
    })
}



//用户解绑
export function unbind() {
    return request({
        url: '/user/unbind',
        method: 'get'
    })
}
//用户解绑
export function addUsersuser(data) {
    return request({
        url: '/user/addUsers',
        method: 'POST',
        data
    })
}